const RatingBar = ({ rating,title }) => {
  // درصد پر شدن نسبت به 5
  const percent = `${(rating / 5) * 100}%`;

  return (
    <div>
       <div
       className="flex justify-between"
       >
        <p>
          {title}
        </p>
        <p>
        {rating}
      </p>
       </div>
    <div
    className="w-full h-2 bg-gray-200 rounded-[5px] overflow-hidden">
     
      <div
        className="h-full bg-aqua transition-all duration-300"
        style={{ width: percent }}
      ></div>
    </div>
    </div>
  );
};

export default RatingBar;
